import React from 'react';
import Hero from '../components/Hero';
import NewsSection from '../components/NewsSection';
import ManifestoSection from '../components/ManifestoSection';
import SocialMarquee from '../components/SocialMarquee';
import CTASection from '../components/CTASection';
import { usePageMeta } from '../hooks/usePageMeta';

const Home = () => {
  usePageMeta({ title: 'GR La Saline - Gymnastique Rythmique à La Réunion', description: 'Club de gymnastique rythmique à La Saline. Cours dès 5 ans, compétitions, galas. Rejoignez-nous pour la saison 2026-2027.' });
  return (
    <div className="bg-black">
      <Hero />
      <NewsSection />
      <ManifestoSection />
      <SocialMarquee />
      <CTASection />
    </div>
  );
};

export default Home;
